import { useMemo } from 'react'
import * as React from 'react'
import gql from 'graphql-tag'
import update from 'immutability-helper'
import styled from 'styled-components'
import {
  ChannelCard_ChannelFragment,
  useGqlFollowListModalMobileQuery,
} from 'generated/graphql'
import useIntersect from '@app.modules/hooks/useIntersect'
import ChannelCard from '../cards/ChannelCard/ChannelCard'
import ChannelCardLoading from '../cards/ChannelCard/ChannelCardLoading'

gql`
  query gqlFollowListModalMobile($first: Int, $after: String) {
    viewerFollowingFeed(first: $first, after: $after) {
      totalCount
      nodes {
        ...channelCard_channel
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

// TODO: cursor기반 pagination 이 제공되면 무한 스크룰 적용 예정

const skeletonArr = ['', '', '', '', '', '', '', '', '', '']

const FollowingListMobile: React.FC = () => {
  const { data, loading, error, fetchMore } = useGqlFollowListModalMobileQuery({
    variables: {
      first: 10,
    },
    fetchPolicy: 'cache-and-network',
  })

  const hasNextPage = useMemo(() => {
    if (!data) return null
    return data.viewerFollowingFeed?.pageInfo.hasNextPage
  }, [data])

  const lastCursor = useMemo(() => {
    if (!data) return null
    return data.viewerFollowingFeed?.pageInfo.endCursor
  }, [data])

  const handleIntersect = () => {
    // validation
    if (!hasNextPage || !lastCursor || loading) return

    const variables = {
      first: 10,
      after: lastCursor,
    }
    if (!fetchMore) return
    fetchMore({
      variables,
      updateQuery: (previousQueryResult, { fetchMoreResult }) => {
        if (!fetchMoreResult || !fetchMoreResult.viewerFollowingFeed)
          return previousQueryResult
        const result = update(previousQueryResult, {
          viewerFollowingFeed: {
            nodes: {
              $push: fetchMoreResult.viewerFollowingFeed.nodes,
            },
            pageInfo: {
              $set: fetchMoreResult.viewerFollowingFeed.pageInfo,
            },
          },
        })
        return result
      },
    })
  }

  const target = useIntersect(handleIntersect, [lastCursor, loading, fetchMore])

  return (
    <StyledWrapper>
      {(() => {
        // loading
        if (!data && loading)
          return (
            <>
              {skeletonArr.map((_, idx) => (
                <ChannelCardLoading key={idx} />
              ))}
            </>
          )
        // error
        if (error)
          return (
            <>
              {skeletonArr.map((_, idx) => (
                <ChannelCardLoading key={idx} />
              ))}
            </>
          )
        // empty
        if (!data?.viewerFollowingFeed?.nodes.length)
          return (
            <div className="nothing-content">
              아직 팔로우한 채널이 없습니다. <br />
              <span>링커리어가 추천하는 채널을 팔로우 해보세요!</span>
            </div>
          )
        // view
        return (
          <>
            {data?.viewerFollowingFeed.nodes
              .filter((el): el is ChannelCard_ChannelFragment => !!el)
              .map((channelCardData) => (
                <div
                  className="channel"
                  key={`FollowingListMobile-${channelCardData.id}`}
                >
                  <ChannelCard enableNewBadge data={channelCardData!} />
                </div>
              ))}
          </>
        )
      })()}
      {hasNextPage && <div ref={target}></div>}
      {hasNextPage && <ChannelCardLoading />}
    </StyledWrapper>
  )
}

export default FollowingListMobile

const StyledWrapper = styled.div`
  font-size: 16px;
  padding: 12px 20px 4px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  .nothing-content {
    padding: 2px 0 12px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;
    span {
      color: #01a0ff;
    }
  }
`
